import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
import * as BullCache from "../util/BullCache";

const apiUrl = process.env.REACT_APP_API_URL;


    var user = BullCache.getFromCache("user");

async function uploadmargin(payload) {
    const result = await axios.post(`${apiUrl}/script/upload/margin/${user.adminId}`, payload, {
    }
    );
    return result.data || [];
}
async function getscriptmargin(payload) {
    const result = await axios.post(apiUrl + "/script/get/margin",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function updatemargin(payload) {
    const result = await axios.post(apiUrl + "/script/update/margin",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
 }





export const ScriptMarginService = {
    uploadmargin,
    getscriptmargin,
    updatemargin
}